const Location = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width='52'
    height='52'
    viewBox='0 0 52 52'
  >
    <path
      fill='#000'
      fillRule='nonzero'
      d='M38.031 26.54l.145-.253A13.855 13.855 0 0 0 40 19.4c0-1.164-.144-2.308-.424-3.414C38.025 9.876 32.429 5.5 25.979 5.5c-6.44 0-12.001 4.367-13.555 10.486A13.856 13.856 0 0 0 12 19.4c0 2.445.635 4.802 1.824 6.887l.145.253.005.037 11.389 19.57c.134.231.362.355.65.353a.695.695 0 0 0 .624-.353l11.39-19.57.004-.037zM24.066 46.902L12.527 27.074l-.006-.043A15.356 15.356 0 0 1 10.5 19.4c0-1.305.163-2.573.47-3.783C12.665 8.941 18.742 4 25.98 4c7.237 0 13.355 4.94 15.05 11.617.307 1.21.47 2.478.47 3.783 0 2.77-.735 5.376-2.021 7.63l-.006.044-11.54 19.828A2.195 2.195 0 0 1 26 48a2.195 2.195 0 0 1-1.934-1.098zM26 23.5a4 4 0 1 1 0-8 4 4 0 0 1 0 8z'
    />
  </svg>
);

export default Location;
